import { SIGN_IN } from '@lumapps/sign-in/keys';

/**
 * this function allows to display the error message corresponding to error param
 *
 * Own-property lookup: a bare index also resolved `Object.prototype` members, so an
 * `?error=toString` query param returned a function instead of a translation key.
 * @param error error code string
 * @returns matching translation key
 */
export const errorMessage = (error: string) => {
    if (error && Object.prototype.hasOwnProperty.call(SIGN_IN, error)) {
        return SIGN_IN[error as keyof typeof SIGN_IN];
    }
    return '';
};
